export const IconCart = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="37"
            height="37"
            fill="none"
            viewBox="0 0 37 37"
        >
            <path
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M1.25.782h1.492c.938 0 1.742.67 1.912 1.592L9.027 26.06h21.188c.906 0 1.692-.625 1.895-1.507L35.7 8.997a1.944 1.944 0 00-1.895-2.381H6.111m24.305 29.166a1.944 1.944 0 110-3.889 1.944 1.944 0 010 3.89zm-19.444 0a1.944 1.944 0 110-3.889 1.944 1.944 0 010 3.89z"
            ></path>
        </svg>
    )
}
